import Bowser from 'bowser';

export interface BrowserEnvironment {
  isMobile: boolean;
  isChromiumBased: boolean;
}

export const detectBrowserEnvironment = (userAgent?: string): BrowserEnvironment => {
  const ua = userAgent ?? (typeof navigator !== 'undefined' ? navigator.userAgent : undefined);

  if (!ua) {
    return { isMobile: false, isChromiumBased: false };
  }

  const parser = Bowser.getParser(ua);
  const platformType = parser.getPlatformType(true);
  const isMobile = platformType === 'mobile' || platformType === 'tablet';

  const engineName = parser.getEngineName().toLowerCase();
  const isChromiumFamily = parser.satisfies({
    chrome: '>=0',
    chromium: '>=0',
    'chromium webview': '>=0',
    edge: '>=0',
    opera: '>=0',
    'opera coast': '>=0',
    'samsung internet for android': '>=0',
    'yandex browser': '>=0',
    electron: '>=0',
  }) ?? false;

  const isChromiumBased = engineName === 'blink' || (isChromiumFamily && engineName !== 'webkit');

  return { isMobile, isChromiumBased };
};

export const isSafari = (): boolean => /apple/i.test(navigator.vendor);
